/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import { Button } from '@ui';
import { AddExclusionModal } from './AddExclusionModal';
const meta = {
    title: 'Features/AiInspectionManager/AddExclusionModal',
    component: AddExclusionModal,
    parameters: { layout: 'centered' }
};
export default meta;
const ACCOUNTS = [
    { value: 1, label: 'Walmart' },
    { value: 2, label: 'Target' }
];
export const Default = {
    render: () => {
        const [open, setOpen] = useState(false);
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { variant: "primary", onClick: () => setOpen(true) }, "Add Exclusion"),
            React.createElement(AddExclusionModal, { isOpen: open, onClose: () => setOpen(false), checkName: "Grammar and Style", accounts: ACCOUNTS, accountTags: ['priority', 'kitchen'], buildingTags: ['downtown', 'north'], onAdd: () => {
                    // Story stub — real fan-out happens in IssuesTypeFlags.
                    setOpen(false);
                } })));
    }
};
